"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var uitk_react_link_1 = require("uitk-react-link");
var analytics_1 = require("../analytics");
var utils_1 = require("../utils");
var CallToAction = (function (_super) {
    __extends(CallToAction, _super);
    function CallToAction(props) {
        var _this = _super.call(this, props) || this;
        var analytics = _this.props.analytics;
        _this.state = { href: undefined };
        _this.paUtility = new analytics_1.PlatformAnalyticsUtility(analytics);
        _this.trackLinkClick = _this.trackLinkClick.bind(_this);
        return _this;
    }
    CallToAction.prototype.componentDidMount = function () {
        var posaLink = this.props.posaLink;
        this.getMIDAppendedURL(posaLink.href);
    };
    CallToAction.prototype.render = function () {
        var _a = this.props, textValue = _a.textValue, posaLink = _a.posaLink;
        var href = this.state.href;
        var splitText = textValue
            .split("{POSaLink}")
            .map(function (v, i) {
            if (v)
                return (react_1.default.createElement("span", { className: "redirect-banner-callToAction-text", key: "callToAction-text" + i, dangerouslySetInnerHTML: { __html: v } }));
        });
        if (splitText.length > 1) {
            var link = (react_1.default.createElement(uitk_react_link_1.UitkLink, { className: "redirect-banner-callToAction-link", theme: "inverse", inline: true, key: "callToAction-link" },
                react_1.default.createElement("a", { href: href, onClick: this.trackLinkClick }, posaLink.value)));
            splitText.splice(1, 0, link);
        }
        return (react_1.default.createElement("span", { className: "redirect-banner-callToAction" }, splitText.filter(function (v) { return v; })));
    };
    CallToAction.prototype.trackLinkClick = function () {
        this.paUtility.trackBannerAction(utils_1.ReferrerType.TRACK_SUBMIT_BANNER);
    };
    CallToAction.prototype.getMIDAppendedURL = function (href) {
        var _this = this;
        var adobeMIDURLPromise = this.paUtility.appendAdobeMIDToURL(href);
        adobeMIDURLPromise.then(function (response) {
            _this.setState({ href: response });
        });
    };
    return CallToAction;
}(react_1.default.Component));
exports.CallToAction = CallToAction;
//# sourceMappingURL=call-to-action.js.map